<template>
  <div v-if="data.did !== undefined">
    <div v-if="this.btnSpinGetDetail == false">
      <v-btn :color="ui.bkgdColor" @click="getDetailDocument()"
              icon v-if="data.size == 'icon'">
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-btn :color="ui.btnColor" @click="getDetailDocument()"
              flat v-if="data.size == 'flat'">
        <v-icon left> source </v-icon>
          data
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";

export default {
  mixins: [getData, storeFunctions, apptheme],
  components: {
    BtnSpin
  },
  props: {
    data: {
      type: Object
    }
  },
  computed: {
    ...mapGetters(["getDetail"])
  },
  data() {
    return {
      valid: false,
      btnSpinGetDetail: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: ""
      }
    };
  },
  methods: {
    getDetailDocument() {
      this.resetStore();
      this.btnSpinGetDetail = true;
      let tag = this.data.tag; // target tag
      let did = this.data.did; //
      this.getDocumentDirectThenPage(tag, did, null);
    }
  }
};
</script>
